module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footers"
  }, [_c('mu-paper', [_c('mu-bottom-nav', {
    attrs: {
      "value": _vm.bottomNav
    },
    on: {
      "change": _vm.handleChange
    }
  }, [_c('mu-bottom-nav-item', {
    attrs: {
      "value": "Index",
      "to": "index",
      "title": "首页",
      "icon": "home"
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    attrs: {
      "value": "Create",
      "to": "create",
      "title": "发布",
      "icon": "create"
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    attrs: {
      "value": "Message",
      "to": "message",
      "title": "消息",
      "icon": "message"
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    attrs: {
      "value": "Userinfo",
      "to": "userinfo",
      "title": "我的",
      "icon": "person"
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    attrs: {
      "value": "About",
      "to": "about",
      "title": "关于",
      "icon": "info"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48254dac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/m-footer.vue
// module id = 155
// module chunks = 2